// extracted by mini-css-extract-plugin
export default {"searchInputClassName":"_87e7844bf600a73b1a4f606c655c724e","searchInputWidthClassName":"cf0889e156907c41086a3850722bdccf"};